/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/prebooktoactual.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_COMMITTEE, GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import jwt_decode from "jwt-decode";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCommitteeMethods extends IPluginMethodMap {
  getCommittee(args: any): Promise<any>;
}

export class GetCommitteeService implements IAgentPlugin {
  readonly methods: IGetCommitteeMethods;

  constructor() {
    this.methods = {
      getCommittee: this.getCommittee.bind(this),
    };
  }

  async getCommittee(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log("args in zero payment service====", pretty(args));
    let filer_apply = args?.criteria ? args?.criteria : {};
    console.log("filet apply====", filer_apply);
    let presentationOptions: any = [],
      defaultPresentation: any = "";

    filer_apply = this.convertCriteria(args?.criteria);
    let variables = {
      // options: {
      //   limit: args?.size ?? 10,
      //   skip: args?.offset ?? 0,
      //   sort: {
      //     field: "createdAt",
      //     order: "desc",
      //   },
      // },
      // filter: {
      //   paymentStats: {
      //     eq: "UnPaid",
      //   },
      //   ...filer_apply,
      // },
    };
    console.log("filter in zero payment user", variables);
    const _filter = {};
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
          },
          fetchPolicy: "network-only",
        });
        const activeItem = presentation?.data?.getPresentations?.content.find(
          (item: any) => item.status === "active"
        );
        defaultPresentation = args?.criteria?.presentation
          ? args?.criteria?.presentation
          : activeItem && activeItem?.id
          ? activeItem?.id
          : null;
        presentationOptions =
          presentation?.data?.getPresentations?.content?.map((_item: any) => {
            return { value: _item?.id, label: _item?.name };
          });
        variables.presentation =
          args?.criteria?.presentation ?? defaultPresentation;

        let filters = {};
        if (args?.criteria?._committee___firstName) {
          filters = {
            ...filters,
            _committee___firstName: {
              contains: args?.criteria?._committee___firstName,
            },
          };
        }
        if (args?.criteria?._committee___lastName) {
          filters = {
            ...filters,
            _committee___lastName: {
              contains: args?.criteria?._committee___lastName,
            },
          };
        }
        if (args?.criteria?._committee___email) {
          filters = {
            ...filters,
            _committee___email: {
              contains: args?.criteria?._committee___email,
            },
          };
        }
        console.log();
        const res = await client.query({
          query: GET_COMMITTEE,
          variables: {
            ...variables,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            filter: {
              ...filters,
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getConvertedPreBookCount?.content
          );

          let _totalPages = res?.data?.getConvertedPreBookCount?.count
            ? Math.ceil(
                parseInt(res?.data?.getConvertedPreBookCount?.count) / 10
              )
            : 1;

          let _currentPage =
            res?.data?.getConvertedPreBookCount?.skip /
              res?.data?.getConvertedPreBookCount?.limit +
            1;
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getConvertedPreBookCount?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getConvertedPreBookCount?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
            defaultPresentation:
              args?.criteria?.presentation ?? defaultPresentation,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    users?.forEach((data?: any) => {
      _rowData.push({
        name: data?._id?.fullName ?? "Null",
        email: data?._id?.email ?? "-",
        count: data?.totalBoxes,
      });
    });
    return _rowData;
  }
}
